<div class="picture {{ imageSize }} {{ imageCenter }}" [ngClass]="{ 'full-width': isFullWidth }">
    <img *ngIf="isSVG" [src]="imageUrl" [alt]="imageAlt" />
    <img *ngIf="!isSVG" [src]="imageUrl" [attr.srcset]="imageUrl" [alt]="imageAlt" />
</div>
